import React, { useEffect, useState } from 'react'
import { useInView } from '../hooks/useInView'
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion'

// Counts from 0 up to `to` the first time it scrolls into view
function CountUp({ to, decimals = 0, duration = 1400 }) {
  const [ref, inView] = useInView({ threshold: 0.4, rootMargin: '0px' })
  const reduced = usePrefersReducedMotion()
  const [value, setValue] = useState(reduced ? to : 0)

  useEffect(() => {
    if (!inView) return undefined
    if (reduced) {
      setValue(to)
      return undefined
    }
    let frame
    let start
    const tick = (time) => {
      start ??= time
      const progress = Math.min((time - start) / duration, 1)
      setValue(to * (1 - (1 - progress) ** 3))
      if (progress < 1) frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [inView, to, duration, reduced])

  return (
    <span ref={ref}>
      {value.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
    </span>
  )
}

export default CountUp
